import { onlyNumericRegex } from "../../../utils/regex";
export const composeCommonInputValues = (values) => {
  //  phone Number
  const Phone = values.Phone
    ? values.Phone.match(onlyNumericRegex).join("")
    : "";
  return {
    ...values,
    Phone,
  };
};

export const appendLocation = (values) => {
  //  Send Location Name and SFID -> Location Name is used by Marketo
  const Select_Location__c = values.location_name;
  const Latest_Application_Toured_Location_ID__c = values.location_id_hidden
    ? values.location_id_hidden
    : values.Target_Location_ID__c;
  const Target_Location_ID__c = values.location_id_hidden
    ? values.location_id_hidden
    : values.Target_Location_ID__c;

  return {
    ...values,
    Select_Location__c,
    Latest_Application_Toured_Location_ID__c,
    Target_Location_ID__c,
  };
};

export const appendLandlord = (values) => {
  const Comments_from_application__c = values.commentCapture;
  return {
    ...values,
    Comments_from_application__c,
    Contact_Type__c: "landlord",
  };
};

export const appendResource = (values) => {
  const marketingEmailOptIn = values.marketingEmailOptIn === "on";
  const Target_Location_ID__c = values.location_id_hidden;
  return { ...values, marketingEmailOptIn, Target_Location_ID__c };
};
